import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const ChipInputStyles: moduleStyleType = {
    chipsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        cursor: 'text',
        p: 1,
        border: 1,
        borderColor: 'border.primary',
        borderRadius: 1,
        backgroundColor: 'background.default',
        '&:hover:not($error)': {
            borderColor: 'primary.main',
        },
    },
    focused: {
        borderColor: 'primary.main',
    },
    error: {
        borderColor: 'error.main',
    },
    chip: {
        float: 'left',
        marginLeft: 1,
    },
    inputRoot: {
        display: 'inline-flex',
        flexWrap: 'wrap',
        flex: 1,
        marginTop: 0,
        minWidth: 70,
        backgroundColor: 'background.default',
        borderRadius: 1,
    },
    input: {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        appearance: 'none',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        float: 'left',
        flex: 1,
    },
}
